module.exports = __webpack_public_path__ + "static/media/pexels-evelina-zhu-5786977.961b646e.jpg";